module.exports = __webpack_public_path__ + "img/hourglass-start.5d600dd1.svg";